import axios, { AxiosError, AxiosRequestConfig } from "axios";

import { CryptoHelper } from "../../utils/helpers/crypto.helper";
import { EnvironmentConfig } from "../../utils/config/environment.config";
import { store, RootState } from "../store";

export const axiosApiService = () => {
  const instance = axios.create({
    baseURL: `${EnvironmentConfig.backendUrl}/api`,
    headers: {
      "Access-Control-Allow-Origin": EnvironmentConfig.frontendUrl,
      "Access-Control-Allow-Headers":
        "POST, GET, PUT, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method",
      "Content-Type": "application/json",
    },
  });

  const headers = instance.defaults.headers;

  const storedToken = localStorage.getItem("token");
  if (storedToken) {
    const decryptedToken: string = CryptoHelper.decrypt(storedToken);
    headers.common["Authorization"] = `Bearer ${decryptedToken}`;
  }

  const handleError = async (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      const state: RootState = store.getState();
      state.auth = {
        events: null,
        menu: null,
        token: null,
        user: null,
        roles: null,
      };
      window.location.reload();
    }
    return Promise.reject(error);
  };

  instance.interceptors.request.use(async (config: any | AxiosRequestConfig) => {
    /* your logic here */
    return config;
  });

  instance.interceptors.response.use((response) => response, handleError);

  return instance;
};
